import React, { useEffect } from 'react';
import { 
  BrowserRouter, 
  Route, 
  Routes, 
  useLocation, 
  Link 
} from 'react-router-dom';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import Home from './pages/Home.js';
import Services from './pages/Services.js';
import Contact from './pages/Contact.js';
import Leadership from './pages/Leadership.js';
import History from './pages/History.js';
import Expertise from './pages/Expertise.js';
import Careers from './pages/Careers.js';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

const PageNotFound = () => (
  <main style={{ textAlign: 'center', padding: '50px' }}>
    <h1>404</h1>
    <p>The page you are looking for does not exist.</p>
    <p><Link to="/">Go back to Home</Link></p>
  </main>
);

// Move ScrollToTop inside the Router context
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

// Main App component with single Router
const App = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Header />
    <div className="main-content">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contacts" element={<Contact />} />
        <Route path="/expertise" element={<Expertise />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/history" element={<History />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
    <Footer />
  </BrowserRouter>
);

export default App;